export default __webpack_public_path__ + "static/title_left_decor_2-19f6cca485191a94d05cdbc1ccb69beb.png";